import { expandRowEpic } from './state/expand-row.epic';
import { reloadEpic } from './state/reload.epic';

export const mainEpics = [reloadEpic, expandRowEpic];
